module.exports = __webpack_public_path__ + "img/hyundai03.3540ed04.png";